/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button, useMediaQuery } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";
import { Logger } from "cms/utils/log/logger";

const Help = () => {
    
    // const anchorRef = useRef(null)
    // const [open, setOpen] = useState(false)
    const matchesXl = useMediaQuery((theme) => theme.breakpoints.down("lg"));
    
    const onHelpClick = async () => {
        Logger.info("Clicked onHelpClick in HeaderContent");
        // Logger.flush()
    };
    
    return (
        <>
            <Button
                color='neutral'
                startIcon={<SVGIcons.common.Help />}
                className="text-button-style"
                onClick={(e) => onHelpClick(e)}
            >
                {!matchesXl ? "Find help" : "Help"}
            </Button>
        </>
    );
};

export { Help };
